import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const BRAND_LOGO_URL = 'https://i.postimg.cc/44mFB7xb/b82d446d_ea30_4c43_a9b9_caf02c25e896_removalai_preview.png';

const footerLinks = [
  { label: 'About Us', href: '/about-us' },
  { label: 'Help Center', href: '/help-center' },
  { label: 'Safety', href: '/safety' },
  { label: 'Contact Us', href: '/contact-us' },
  { label: 'List Your Property', href: '/listings', isAction: true },
  { label: 'Terms of Service', href: '/terms-of-service' },
  { label: 'Privacy Policy', href: '/privacy-policy' },
  { label: 'Cookie Policy', href: '/cookie-policy' },
  { label: 'Sitemap', href: '/sitemap' }
];

const Footer = ({ onListYourProperty }) => {
  const navigate = useNavigate();

  const handleLinkClick = (link) => {
    if (link.isAction && onListYourProperty) {
      onListYourProperty();
      return;
    }
    window.scrollTo(0, 0);
    navigate(link.href);
  };

  return (
    <footer className="bg-white border-t border-gray-200 mt-12 relative z-20 w-full">
      <div className="py-5 w-full">
        <div className="mb-4 w-full rounded-[1.75rem] border border-blue-100 bg-white px-4 py-4 md:px-5 md:py-5">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
            <div className="max-w-2xl">
              <h3 className="text-base font-semibold text-blue-700 mb-1">GhanaStay</h3>
              <p className="text-xs text-blue-600">Find homes, connect with property owners, and access the key legal and support pages you need in one place.</p>
            </div>
            <div className="flex items-center gap-4 md:gap-6">
              <Link to="/privacy-policy" className="text-xs font-medium text-blue-600 hover:text-blue-800 transition-colors duration-200">
                Privacy-first platform information
              </Link>
              <img
                src={BRAND_LOGO_URL}
                alt="GhanaStay"
                className="h-14 w-24 object-contain object-right"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5 w-full">
            {footerLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => handleLinkClick(link)}
                className="text-left px-3.5 py-2.5 rounded-xl bg-white border border-blue-100 text-xs text-gray-700 hover:border-blue-300 hover:bg-blue-50 transition-colors duration-200"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>
        
        <div className="border-t border-gray-200 pt-4 flex flex-col md:flex-row justify-between items-center w-full">
          <div className="text-[11px] text-gray-600 mb-3 md:mb-0">
            © 2026 GhanaStay. All rights reserved.
          </div>
          <div className="flex flex-wrap items-center gap-3 text-[11px] text-gray-500">
            <span>Trusted rental discovery for Ghana</span>
            <span>Support</span>
            <span>Legal</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
